import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useHybrisSegment } from '@telialt/utils/src/segment';

import { SearchSuggestionClickHandler, SearchSuggestionItemWithQueryKey } from '../../../model';
import { SEARCH_TEST_ID } from '../../../test/test-ids';
import { getSearchResultsPath } from '../../../utils/paths';
import { ButtonSuggestions } from '../../ButtonSuggestions/ButtonSuggestions';
import { ButtonSuggestionItemProps } from '../../ButtonSuggestions/model';
import { PopularQueriesWrapper, SectionHeading } from '../SearchSuggestions.styles';

type Props = {
    suggestions: SearchSuggestionItemWithQueryKey[];
    onClick?: SearchSuggestionClickHandler;
};

const SEARCH_SUGGESTIONS_POPULAR_QUERIES = 'search-suggestions-popular-queries';

export const PopularQueries: FC<Props> = ({ suggestions, onClick }) => {
    const { t } = useTranslations();

    const segment = useHybrisSegment();

    if (!suggestions.length) {
        return null;
    }

    const items: ButtonSuggestionItemProps[] = suggestions.map((item) => {
        return {
            keyword: item.suggestion,
            url: getSearchResultsPath(segment, item.suggestion),
            queryKey: item.queryKey,
        };
    });

    return (
        <PopularQueriesWrapper
            data-test={SEARCH_TEST_ID.SUGGESTIONS_POPULAR_QUERIES}
            aria-labelledby={SEARCH_SUGGESTIONS_POPULAR_QUERIES}
        >
            <SectionHeading tag="h2" variant="title-100" id={SEARCH_SUGGESTIONS_POPULAR_QUERIES}>
                {t['search.suggestions.popular.title']}
            </SectionHeading>
            <ButtonSuggestions items={items} onClick={onClick} />
        </PopularQueriesWrapper>
    );
};
